export const HOTEL = 'HOTEL';
export const CREATE_HOTEL_REQUEST = `${HOTEL}/createHotelRequest`;
export const GET_HOTEL_REQUEST = `${HOTEL}/getHotelRequest`;
export const REMOVE_HOTEL_REQUEST = `${HOTEL}/removeHotelRequest`;
export const UPDATE_HOTEL_REQUEST = `${HOTEL}/updateHotelRequest`;
export const GET_HOTEL_MANAGERS_REQUEST = `${HOTEL}/getHotelManagersRequest`;
export const GET_ASSIGNABLE_MANAGER = `${HOTEL}/getAssignableManagerRequest`;
